import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./msalConfig";
import { AuthProvider } from "./AuthContext";
import App from "./App";

const msalInstance = window.__MSAL_INSTANCE__ || new PublicClientApplication(msalConfig);
window.__MSAL_INSTANCE__ = msalInstance;

createRoot(document.getElementById("root")).render(
  <MsalProvider instance={msalInstance}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </MsalProvider>
);
